import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';

const style = {
  zIndex: 2000,
  width: '350px',
  position: 'fixed',
  top: '20px',
  right: '20px',
};

const SuccessAlert = ({ apiRes, setApiRes }) => {
  const [alert, setAlert] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setAlert(false);
      setApiRes(prev => ({
        ...prev,
        showAlert: false,
      }));
    }, 5000);
  }, []);

  if (!alert) {
    return null;
  }

  return (
    <Alert severity="success" style={style}>
      <AlertTitle>Success</AlertTitle>
      {apiRes.successMsg}
    </Alert>
  )
};

SuccessAlert.propTypes = {
  apiRes: PropTypes.object.isRequired,
  setApiRes: PropTypes.func.isRequired,
};

export default SuccessAlert;